






















































































import Vue from 'vue'

import { QAQC, CreateQAQC, QAQCParameter } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      QAQCs: [] as QAQC[],
      qaqc: { parameters: [] as QAQCParameter[] } as QAQC,
    }
  },

  methods: {
    // ------------------------------------------------------------------------------
    // Keyboard & mouse Events
    // ------------------------------------------------------------------------------
    onRowClick(qaqc: QAQC) {
      this.$router.push({
        path: `/cems/setting/qaqc/${qaqc.id}`,
      })
    },

    addParameter() {
      const newParameter = { name: '' } as QAQCParameter
      this.qaqc.parameters.push(newParameter)
    },

    deleteParameter(index: number) {
      this.qaqc.parameters.splice(index, 1)
    },
    resetParameter() {
      this.qaqc.parameters = []
    },

    cancelCreate() {
      this.$router.push('/cems/setting/qaqc')
    },

    async onSubmit(event: Event) {
      event.preventDefault()
      await CreateQAQC(this.qaqc)
      this.$router.push('/cems/setting/qaqc')
    },
  },
})
